import React from 'react'
import { connect } from 'react-redux'
import { Button as ButtonBS } from 'react-bootstrap'

import { update, createPlaylist } from '../../../store/Modal/types/PlaylistCreate/actions'
import { loadVideolists } from '../../../store/ContentVideolists/actions'

import Header from '../components/header'

import InputText from '../../Form/InputText'
import Select from '../../Form/Select'
import CheckEnabledSVG from '../../SVG/CheckEnabled'
import CheckDisabledSVG from '../../SVG/CheckDisabled'
import Button from '../../Button'

class PlaylistCreate extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            name: false,
            description: false,
            videolist: false,
            sumbitDisabled: true,
            address: '',
            isadvert: false

        }
        this.hSubmit = this.hSubmit.bind(this)
        this.hInputText = this.hInputText.bind(this)
        this.validateForm = this.validateFrom.bind(this)
    }

    hInputText({ name, value }, event) {
        if (name && value) {
            this.setState(() => ({
                [name]: value
            }), this.validateFrom)
        }
        console.log(this.state)
    }

    hSubmit() {
        this.props.createPlaylist({
            name: this.state.name,
            description: this.state.description || "",
            videolist: this.state.videolist,
            ...this.props.options?.['playlist-stream'] ? {
                address: this.state.address,
                isadvert: this.state.isadvert
            } : {}
        })
    }

    validateFrom() {
        if (this.state.name
            && (typeof this.state.name === "string" && this.state.name.length > 1)
            // && (typeof this.state.description === "string" && this.state.description.length > 3)
        ) {
            this.setState({ sumbitDisabled: false })
        } else {
            this.setState({ sumbitDisabled: true })
        }
    }

    componentDidMount() {
        this.props.update()
        this.props.loadVideolists()
    }

    render() {
        let videolists2 = [{ title: 'Не привязывать', value: -1, id: -1 }, ...this.props.videolists.map((list, index) => {
            return { title: list.name, value: list.id, id: list.id }
        })]
        return (
            <div className="ModalOneInput">
                <Header
                    title="Создание музыкального плейлиста"
                    toggleOpened={this.props.toggleOpened}
                />
                <InputText
                    label="Название"

                    attrs={{
                        name: "name",
                        placeholder: "Введите название плейлиста",
                    }}
                    onChange={this.hInputText}
                />
                <div style={{ marginTop: 30 }}>
                    <InputText
                        label="Описание"
                        attrs={{
                            name: "description",
                            placeholder: "Введите описание"
                        }}
                        onChange={this.hInputText}
                    />
                </div>
                <div style={{ marginTop: 30 }}>
                    <Select
                        label="Привязать фоновое видео"
                        type="options"
                        placeholder={"Не привязывать"}
                        name="videolist"
                        options={videolists2}
                        onChange={this.hInputText}
                    />
                </div>
                {this.props.options?.['playlist-stream'] && <>
                    <div style={{ marginTop: 30 }}>
                        <InputText
                            label="Адрес потока (прямая ссылка на нерасшифрованный HTTP аудиопоток)"
                            attrs={{
                                name: "address",
                                placeholder: "Адрес потока (прямая ссылка на нерасшифрованный HTTP аудиопоток)"
                            }}
                            onChange={this.hInputText}
                        />
                    </div>
                    <div style={{ marginTop: 30 }}>
                        <div style={{ width: 440, height: 40 }}>
                            <Button onClick={() => this.setState(() => ({
                                isadvert: !this.state.isadvert
                            }), this.validateFrom)}>
                                {!this.state.isadvert ?
                                    <CheckDisabledSVG size='sm' />
                                    :
                                    <CheckEnabledSVG size='sm' />
                                }
                                Проигрывать в потоке собственную рекламу
                            </Button>
                        </div>
                    </div>

                </>
                }

                <div className="Modal__footer">
                    <ButtonBS onClick={this.hSubmit} variant="primary" disabled={this.state.sumbitDisabled || this.props.loading}>
                        {this.props.loading ? "Сохранение..." : "Добавить"}
                    </ButtonBS>
                </div>
            </div>
        )
    }
}

const stateToProps = state => ({
    loading: state.modalPlaylistCreate.loading,
    videolists: state.videolists.allVideolists,
    options: state.login.user.options
})

const actionsToProps = {
    update, createPlaylist, loadVideolists
}



export default connect(stateToProps, actionsToProps)(PlaylistCreate)